import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import Popover from 'components/generic/Popover'
import ShareDropdown from './ShareDropdown'
import { ShareIcon } from '../ShareIcon'

import s from './ShareButtonDropDown.module.css'

const ShareButton = (props) => {
  const { url } = props
  const targetRef = useRef(null)

  const shareBtnClass = s.root

  return (
    <>
      <div className={shareBtnClass} ref={targetRef} role="menu">
        <ShareIcon />
      </div>

      <Popover type="click" targetRef={targetRef} className="share-dropdown">
        <ShareDropdown url={url} />
      </Popover>
    </>
  )
}

ShareButton.defaultProps = {
  type: 'row',
}

ShareButton.propTypes = {
  type: PropTypes.oneOf(['row', 'col']),
  url: PropTypes.string.isRequired,
}

export default ShareButton
